<template>
  <div class="ai-msg">
    <MarkdownItVue :content="content" @render-complete="$emit('completed')" ></MarkdownItVue>
  </div>
</template>

<script>
import MarkdownItVue from 'markdown-it-vue';

export default {
  components: {
    MarkdownItVue,
  },
  props: {
    msgInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    content() {
      const { content = '' } = this.msgInfo;
      return content.replace(/(\\n|\\r|\\r\\n)/g, '\n');
    },
  },
};
</script>

<style>
.ai-msg {
    /* display: inline-block; */
    width: fit-content;
    border-radius: 12px 12px 12px 0;
    padding: 14px;
    max-width: 240px;
    background-color: #fff;
    font-style: 14px;
    font-family: Roboto;
    color: rgba(30, 30, 30, 1);
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
